// frontend/src/components/ShareProject.js

import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  TextField, 
  Button, 
  Paper,
  Snackbar,
  Alert
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import api from '../services/api';

function ShareProject({ projectId }) {
  const [surveyLink, setSurveyLink] = useState('');
  const [error, setError] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  useEffect(() => {
    api.get(`/projects/${projectId}/share`)
      .then(response => {
        const baseUrl = window.location.origin;
        setSurveyLink(`${baseUrl}/survey/${response.data.project_id}/`);
      })
      .catch(error => {
        console.error('Error fetching survey link:', error);
        setError('Failed to generate survey link.');
      });
  }, [projectId]);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(surveyLink)
      .then(() => {
        setOpenSnackbar(true);
      })
      .catch(err => {
        console.error('Failed to copy link: ', err);
        setError('Failed to copy link to clipboard.');
      });
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', p: 3 }}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        Share this survey with your participants:
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {surveyLink && (
        <Box>
          <Paper 
            variant="outlined" 
            sx={{ 
              display: 'flex',
              mb: 3,
              overflow: 'hidden'
            }}
          >
            <TextField
              fullWidth
              value={surveyLink}
              variant="outlined"
              size="small"
              InputProps={{
                readOnly: true,
                sx: { 
                  borderRadius: '4px 0 0 4px',
                  '& fieldset': { 
                    borderRight: 'none',
                    borderRadius: '4px 0 0 4px'
                  }
                }
              }}
            />
            <Button
              variant="contained"
              onClick={handleCopyLink}
              startIcon={<ContentCopyIcon />}
              sx={{
                borderRadius: '0 4px 4px 0',
                minWidth: '120px'
              }}
            >
              Copy
            </Button>
          </Paper>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Append your customer ID to the end of this link.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Example: {surveyLink}customer123
          </Typography>
        </Box>
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ 
          vertical: 'bottom', 
          horizontal: 'right' 
        }}
        sx={{ 
          bottom: { xs: 16, sm: 24 },  // Adjust bottom margin
          right: { xs: 16, sm: 24 }    // Adjust right margin
        }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity="success" 
          sx={{ width: '100%' }}
        >
          Link copied to clipboard!
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default ShareProject;
